import type { OrganizationLanguages } from "../../services/apis/organization.api";
import type { AppDispatch } from "../store";
import {
    updateOrganizationAssessmentLanguages,
    updateOrganizationCustomization,
} from "./organization.slice";

/**
 * Puts the language settings the server confirmed into every stored copy of
 * the organisation: the selected one and the two lists. The reducers match by
 * organisation id, so the selected organisation changes only when it is this
 * one, and another organisation's list copies change without it.
 *
 * Every screen that changes these settings calls it once the server has
 * answered (the Languages section of Feature Settings, the review queue's
 * header switch), so none of them leaves a stale copy behind for the others.
 */
export function publishOrganizationLanguages(
    dispatch: AppDispatch,
    organizationId: string,
    next: OrganizationLanguages
): void {
    dispatch(
        updateOrganizationCustomization({
            organizationId,
            customization: {
                translation: {
                    defaultLanguage: next.defaultLanguage,
                    showUnreviewedAI: next.showUnreviewedAI,
                },
            },
        })
    );
    dispatch(
        updateOrganizationAssessmentLanguages({
            organizationId,
            assessmentLanguages: next.assessmentLanguages,
        })
    );
}
